export default __webpack_public_path__ + "static/media/ComingSoonTeleConsultation.d2ef90f6.svg";